/**
 * @generated SignedSource<<8962a21aa3eece1945533a1010dd7199>>
 * @relayHash c08a73673f7cce695a80b29ecd0e93d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b45a969020533b8c00a24c1589be0d7bc838f5f3f7c46fc0f3d16186de0473c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type WorkSuggestionsContextAri = {
  projectAri: string;
  sprintAri?: string | null | undefined;
};
export type main_boardWorkSuggestions_Query$variables = {
  cloudId: string;
  contextAri: WorkSuggestionsContextAri;
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  isIssueDueSoonEnabled: boolean;
  isPrRecentCommentEnabled: boolean;
  projectAri: string;
};
export type main_boardWorkSuggestions_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_insightsNextBestTask_TaskPanelController_dataGql">;
};
export type main_boardWorkSuggestions_Query = {
  response: main_boardWorkSuggestions_Query$data;
  variables: main_boardWorkSuggestions_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIssueDueSoonEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrRecentCommentEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v8 = {
  "kind": "Variable",
  "name": "contextAri",
  "variableName": "contextAri"
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "concreteType": "WorkSuggestionsOrderScore",
  "kind": "LinkedField",
  "name": "orderScore",
  "plural": false,
  "selections": [
    {
      "concreteType": "WorkSuggestionsOrderScores",
      "kind": "LinkedField",
      "name": "byTaskType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "major"
        },
        {
          "kind": "ScalarField",
          "name": "minor"
        }
      ]
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "title"
},
v14 = {
  "kind": "ScalarField",
  "name": "issueKey"
},
v15 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v16 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v17 = {
  "kind": "ScalarField",
  "name": "url"
},
v18 = {
  "kind": "ScalarField",
  "name": "approvalsCount"
},
v19 = {
  "kind": "ScalarField",
  "name": "commentCount"
},
v20 = {
  "kind": "ScalarField",
  "name": "repositoryName"
},
v21 = {
  "kind": "ScalarField",
  "name": "providerName"
},
v22 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_boardWorkSuggestions_Query",
    "selections": [
      {
        "args": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          {
            "kind": "Variable",
            "name": "isIssueDueSoonEnabled",
            "variableName": "isIssueDueSoonEnabled"
          },
          {
            "kind": "Variable",
            "name": "isPrRecentCommentEnabled",
            "variableName": "isPrRecentCommentEnabled"
          },
          {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "projectAri"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_insightsNextBestTask_TaskPanelController_dataGql"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_boardWorkSuggestions_Query",
    "selections": [
      {
        "concreteType": "WorkSuggestions",
        "kind": "LinkedField",
        "name": "workSuggestions",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "WorkSuggestionsConnection",
            "kind": "LinkedField",
            "name": "workSuggestionsByContextAri",
            "plural": false,
            "selections": [
              {
                "concreteType": "WorkSuggestionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isWorkSuggestionsCommon"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "numberOfFailedBuilds"
                          },
                          (v16/*: any*/)
                        ],
                        "type": "WorkSuggestionsBuildTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "numberOfFailedDeployments"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "environmentType"
                          },
                          (v16/*: any*/)
                        ],
                        "type": "WorkSuggestionsDeploymentTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "type": "WorkSuggestionsPullRequestReviewTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "needsWorkCount"
                          },
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "type": "WorkSuggestionsPullRequestNeedsWorkTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v15/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "securityContainerName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "introducedDate"
                          }
                        ],
                        "type": "WorkSuggestionsCriticalVulnerabilityTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "concreteType": "WorkSuggestionsBlockedIssue",
                            "kind": "LinkedField",
                            "name": "blockedIssues",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v15/*: any*/)
                        ],
                        "type": "WorkSuggestionsBlockingIssueTask"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v9/*: any*/),
            "filters": [
              "contextAri"
            ],
            "handle": "connection",
            "key": "panel_workSuggestionsByContextAri",
            "kind": "LinkedHandle",
            "name": "workSuggestionsByContextAri"
          },
          {
            "args": [
              (v7/*: any*/),
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "projectAris.0",
                    "variableName": "projectAri"
                  }
                ],
                "kind": "ListValue",
                "name": "projectAris"
              },
              {
                "kind": "Literal",
                "name": "sprintAutoDiscoveryLimit",
                "value": 0
              }
            ],
            "concreteType": "WorkSuggestionsByProjectsResponse",
            "kind": "LinkedField",
            "name": "suggestionsByProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "WorkSuggestionsPullRequestDraftTask",
                "kind": "LinkedField",
                "name": "draftPRSuggestions",
                "plural": true,
                "selections": (v22/*: any*/)
              },
              {
                "concreteType": "WorkSuggestionsPullRequestInactiveTask",
                "kind": "LinkedField",
                "name": "inactivePRSuggestions",
                "plural": true,
                "selections": (v22/*: any*/)
              },
              {
                "condition": "isIssueDueSoonEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "WorkSuggestionsIssueDueSoonTask",
                    "kind": "LinkedField",
                    "name": "issueDueSoonSuggestions",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "WorkSuggestionsJiraAssignee",
                        "kind": "LinkedField",
                        "name": "assigneeProfile",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "pictureUrl"
                          },
                          (v23/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "dueDate"
                      },
                      {
                        "concreteType": "WorkSuggestionsIssueStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/)
                        ]
                      },
                      (v14/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "WorkSuggestionsPullRequestSuggestionsResponse",
                "kind": "LinkedField",
                "name": "recentPullRequests",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "WorkSuggestionsPRMergeableTask",
                    "kind": "LinkedField",
                    "name": "mergeableSuggestions",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPrRecentCommentEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "WorkSuggestionsPRCommentsTask",
                        "kind": "LinkedField",
                        "name": "newCommentsSuggestions",
                        "plural": true,
                        "selections": (v22/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0b45a969020533b8c00a24c1589be0d7bc838f5f3f7c46fc0f3d16186de0473c",
    "metadata": {},
    "name": "main_boardWorkSuggestions_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5c5a2c0c5b5ca2389af8606d0572c150";

export default node;
